import { InjectionToken } from '@angular/core';

const SPINNER_SERVICE = new InjectionToken('SpinnerService');

/**
 * Generated bundle index. Do not edit.
 */

export { SPINNER_SERVICE };
